import { Card, Col, Row, Tag, Typography } from 'antd'
import { Link } from 'react-router-dom'

const { Title, Text, Paragraph } = Typography

const CGAPage = () => {
  return (
    <Card>
      <Row>
        <Col span={24}>
          <Title level={3}>CONDITIONS GÉNÉRALES D&apos;ABONNEMENT (CGA)</Title>
          <Paragraph>
            <Tag color="pink">Version mise à jour au 28/12/2024</Tag>
          </Paragraph>

          <Title level={4}>PRÉAMBULE</Title>
          <Paragraph>
            Les présentes Conditions Générales d&apos;Abonnement (ci-après les
            &laquo;&nbsp;CGA&nbsp;&raquo;) régissent les modalités de
            souscription et d&apos;utilisation des Services fournis par
            SUPPLEMENT BACON, Société par actions simplifiée unipersonnelle
            (SASU) au capital de 500,00 &euro;, immatriculée au Registre du
            Commerce et des Sociétés de Paris sous le numéro 892 691 650, et
            dont le siège social est situé au 7 rue Narcisse Diaz, 75016 Paris
            (ci-après &laquo;&nbsp;SUPPLEMENT BACON&nbsp;&raquo;). Ces CGA
            constituent un cadre contractuel clair et précis visant à encadrer
            les droits et obligations des Parties dans le cadre de
            l&apos;utilisation des Services.
          </Paragraph>

          <Title level={4}>ARTICLE 1 – DÉFINITIONS</Title>
          <Paragraph>
            Dans les présentes CGA, les termes suivants, lorsqu&apos;ils sont
            employés avec une majuscule, auront la signification qui leur est
            attribuée ci-après&nbsp;:
          </Paragraph>
          <Paragraph>
            <strong>Client&nbsp;:</strong> Toute personne physique ou morale,
            dûment habilitée, souscrivant aux Services proposés par SUPPLEMENT
            BACON et responsable de leur utilisation conformément aux CGA.
          </Paragraph>
          <Paragraph>
            <strong>Services&nbsp;:</strong> Ensemble des prestations fournies
            par la plateforme&nbsp;
            <Link to="https://echow.app">Echow.app</Link>, comprenant notamment
            la connexion et l&apos;intégration avec un ou plusieurs comptes
            Instagram, la gestion automatisée et personnalisée des réponses aux
            mentions en Story, ainsi que l&apos;accès à un tableau de bord
            d&apos;analyse détaillée.
          </Paragraph>
          <Paragraph>
            <strong>Plateforme&nbsp;:</strong> Interface accessible à
            l&apos;adresse&nbsp;
            <Link to="https://www.echow.app">www.echow.app</Link>, permettant au
            Client de gérer et d&apos;utiliser les Services.
          </Paragraph>
          <Paragraph>
            <strong>Abonnement&nbsp;:</strong> Contrat lié à l&apos;accès aux
            Services pour un seul compte Instagram, à durée déterminée ou
            indéterminée, renouvelable par tacite reconduction, moyennant le
            paiement du Tarif convenu.
          </Paragraph>
          <Paragraph>
            <strong>Tarif Mensuel&nbsp;:</strong> Montant de l&apos;Abonnement
            mensuel par compte Instagram, fixé à 29 &euro; TTC, payé à
            l&apos;avance pour chaque période de 30 jours consécutifs.
          </Paragraph>
          <Paragraph>
            <strong>Tarif Annuel&nbsp;:</strong> Montant de l&apos;Abonnement
            annuel par compte Instagram, fixé à 290 &euro; TTC, correspondant à
            un engagement ferme de 12 mois et payable en une seule fois à la
            souscription.
          </Paragraph>
          <Paragraph>
            <strong>Parties&nbsp;:</strong> Ensemble constitué du Client et de
            SUPPLEMENT BACON, agissant dans le cadre des présentes CGA.
          </Paragraph>
          <Paragraph>
            <strong>Compte&nbsp;:</strong> Espace personnel et sécurisé créé par
            le Client sur la Plateforme afin d&apos;accéder aux Services et de
            gérer son Abonnement.
          </Paragraph>
          <Paragraph>
            <strong>Données Client&nbsp;:</strong> Ensemble des informations,
            contenus, fichiers et médias fournis par le Client ou générés via
            l&apos;utilisation des Services.
          </Paragraph>
          <Paragraph>
            <strong>Force Majeure&nbsp;:</strong> Tout événement imprévisible,
            irrésistible et échappant au contrôle raisonnable des Parties,
            incluant, sans s&apos;y limiter, les pannes technologiques,
            interruptions de services tierces ou catastrophes naturelles,
            rendant impossible l&apos;exécution des obligations contractuelles.
          </Paragraph>

          <Title level={4}>ARTICLE 2 – OBJET DES CGA</Title>
          <Paragraph>
            Les présentes CGA ont pour objet de définir les termes et conditions
            encadrant la fourniture des Services par SUPPLEMENT BACON et
            l&apos;utilisation de ceux-ci par le Client. Elles visent à établir
            une relation contractuelle équilibrée et transparente tout en
            préservant les intérêts de chaque Partie.
          </Paragraph>

          <Title level={4}>ARTICLE 3 – SOUSCRIPTION ET DURÉE</Title>
          <Paragraph>
            Le Client peut souscrire un Abonnement via la Plateforme en suivant
            la procédure d&apos;inscription en ligne. Chaque Abonnement est lié
            à un seul compte Instagram.
          </Paragraph>
          <Paragraph>
            La validation de la souscription implique l&apos;acceptation
            expresse des présentes CGA.
          </Paragraph>
          <Paragraph>
            L&apos;Abonnement annuel entraîne un engagement ferme pour une durée
            de 12 mois, sans possibilité de remboursement en cas de résiliation
            anticipée par le Client.
          </Paragraph>
          <Paragraph>
            Sauf résiliation préalable notifiée par le Client dans un délai
            minimum de 30 jours avant l&apos;échéance, l&apos;Abonnement est
            renouvelé automatiquement pour une période équivalente.
          </Paragraph>

          <Title level={4}>ARTICLE 4 – TARIFS ET CONDITIONS DE PAIEMENT</Title>
          <Paragraph>
            Les tarifs applicables sont indiqués en euros TTC et comprennent
            toutes les taxes en vigueur. Ils sont les suivants&nbsp;:
          </Paragraph>
          <Paragraph>
            - <strong>Tarif Mensuel&nbsp;:</strong> 29 &euro; TTC par compte
            Instagram.
          </Paragraph>
          <Paragraph>
            - <strong>Tarif Annuel&nbsp;:</strong> 290 &euro; TTC par compte
            Instagram.
          </Paragraph>
          <Paragraph>
            Le paiement est effectué à l&apos;avance par carte bancaire via une
            solution sécurisée, garantissant la protection des Données bancaires
            du Client.
          </Paragraph>
          <Paragraph>
            SUPPLEMENT BACON se réserve le droit de réviser ses tarifs, sous
            réserve d&apos;en informer le Client par tout moyen approprié au
            moins 30 jours avant l&apos;entrée en vigueur des nouveaux tarifs.
            Le Client peut, en cas de désaccord, résilier son Abonnement
            conformément à l&apos;article 8 des présentes.
          </Paragraph>

          <Title level={4}>ARTICLE 5 – UTILISATION DES SERVICES</Title>
          <Paragraph>
            Le Client s&apos;engage à utiliser les Services dans le respect des
            présentes CGA et des lois en vigueur, en s&apos;abstenant de tout
            usage abusif ou illicite.
          </Paragraph>
          <Paragraph>
            SUPPLEMENT BACON met en œuvre tous les moyens raisonnables pour
            assurer un accès continu aux Services, mais ne peut garantir leur
            disponibilité ininterrompue, notamment en cas de Force Majeure, de
            maintenance, ou d&apos;interruption des services tiers (tels que
            l&apos;API d&apos;Instagram). En cas d&apos;interruption, SUPPLEMENT
            BACON déploiera ses meilleurs efforts pour rétablir l&apos;accès
            dans les meilleurs délais.
          </Paragraph>
          <Paragraph>
            SUPPLEMENT BACON ne saurait être tenue responsable de la suspension
            ou de la fermeture du compte Instagram d&apos;un Client par la
            société Meta, cette dernière relevant exclusivement des politiques
            et décisions de ladite société.
          </Paragraph>

          <Title level={4}>ARTICLE 6 – RESPONSABILITÉS</Title>
          <Paragraph>
            Le Client demeure seul responsable des contenus et Données
            qu&apos;il fournit dans le cadre de l&apos;utilisation des Services.
            Il garantit à SUPPLEMENT BACON que ces contenus sont conformes aux
            lois en vigueur et ne violent aucun droit de tiers.
          </Paragraph>
          <Paragraph>
            SUPPLEMENT BACON ne saurait être tenue responsable des conséquences
            liées à l&apos;interruption temporaire ou définitive des Services,
            notamment lorsque cette interruption résulte de facteurs
            indépendants de sa volonté (tels que la désactivation de l&apos;API
            d&apos;Instagram par Meta).
          </Paragraph>
          <Paragraph>
            En cas de Force Majeure ou de non-conformité des Données Client,
            SUPPLEMENT BACON se réserve le droit de suspendre ou de résilier
            l&apos;Abonnement, sans préavis ni indemnité pour le Client.
          </Paragraph>

          <Title level={4}>ARTICLE 7 – PROPRIÉTÉ INTELLECTUELLE</Title>
          <Paragraph>
            SUPPLEMENT BACON demeure seule propriétaire de l&apos;ensemble des
            droits de propriété intellectuelle relatifs à la Plateforme et aux
            Services, y compris les logiciels, graphismes, et contenus proposés.
          </Paragraph>
          <Paragraph>
            Le Client bénéficie d&apos;un droit d&apos;utilisation personnel,
            non exclusif et non cessible, strictement limité à l&apos;exécution
            de l&apos;Abonnement.
          </Paragraph>
          <Paragraph>
            Toute reproduction, modification, ou exploitation non autorisée des
            éléments protégés par les droits de propriété intellectuelle de
            SUPPLEMENT BACON est strictement interdite.
          </Paragraph>

          <Title level={4}>ARTICLE 8 – RÉSILIATION</Title>
          <Paragraph>
            Le Client peut résilier son Abonnement mensuel à tout moment, avec
            effet à la fin de la période en cours. Toute somme déjà versée reste
            acquise à SUPPLEMENT BACON.
          </Paragraph>
          <Paragraph>
            En cas d&apos;Abonnement annuel, la résiliation anticipée ne donne
            lieu à aucun remboursement. L&apos;engagement ferme de 12 mois est
            maintenu.
          </Paragraph>
          <Paragraph>
            SUPPLEMENT BACON peut résilier unilatéralement l&apos;Abonnement en
            cas de manquement grave du Client à ses obligations ou
            d&apos;utilisation illicite des Services.
          </Paragraph>

          <Title level={4}>ARTICLE 9 – MODIFICATIONS DES CGA</Title>
          <Paragraph>
            SUPPLEMENT BACON se réserve le droit de modifier les présentes CGA à
            tout moment, notamment pour s&apos;adapter à l&apos;évolution
            législative ou technique. Toute modification sera notifiée au Client
            par tout moyen approprié au moins 30 jours avant son entrée en
            vigueur. En cas de désaccord, le Client pourra résilier son
            Abonnement sans frais avant la date d&apos;application des nouvelles
            conditions.
          </Paragraph>

          <Title level={4}>ARTICLE 10 – DROIT APPLICABLE ET LITIGES</Title>
          <Paragraph>
            Les présentes CGA sont soumises au droit français. Tout litige
            relatif à leur interprétation, leur validité ou leur exécution sera
            soumis à la compétence exclusive des tribunaux de Paris.
          </Paragraph>
          <Paragraph>
            Pour toute question ou assistance, le Client est invité à contacter
            SUPPLEMENT BACON par e-mail à l&apos;adresse suivante&nbsp;:{' '}
            <Link to="mailto:support@echow.app">support@echow.app</Link>.
          </Paragraph>
        </Col>
      </Row>
    </Card>
  )
}

export default CGAPage
